<template>
  <components :is="tabsContent[active].name"></components>
</template>

<script>
import cpjs from "@/components/superhttp/cpjs.vue";
import tcgm from "@/components/superhttp/tcgm.vue";
import syzn from "@/components/superhttp/syzn.vue";
import cjwt from "@/components/superhttp/cjwt.vue";
export default {
  props: {
    active: {
      tyepe: [Number, String],
      default: 0,
    },
  },
  components: {
    cpjs,
    tcgm,
    syzn,
    cjwt,
  },
  data() {
    return {
      tabsContent: [
        { id: 0, name: "cpjs" },
        { id: 1, name: "tcgm" },
        { id: 2, name: "syzn" },
        { id: 3, name: "cjwt" },
      ],
    };
  },
};
</script>
